<template>
  <div class="flex flex-col gap-y-3">
    <div class="ltr:font-sans text-sm text-brand-black-body border-b border-brand-gray-300">
      <h4 class="text-xl text-primary">{{ $t('authenticatorApp') }}</h4>
      <p>{{ $t('authenticatorAppMSG1') }} {{ $t('authenticatorAppMSG2') }}</p>
      <p>{{ $t('authenticatorAppMSG3') }}</p>
      <ol class="list-decimal px-6 py-4 flex flex-col gap-y-2">
        <li>
          <span>
            {{ $t('authenticatorAppStep1MSG') }}
            <button class="text-primary" @click="$emit('onShowModal', 'authenticatorAppStep1Note')">
              {{ $t('authenticatorAppStep1Note') }}
            </button>
          </span>
        </li>
        <template v-if="otpSettings">
          <li>
            <div class="flex flex-col items-start gap-y-2">
              <span>{{ $t('authenticatorAppStep2MSG') }}</span>
              <img
                :src="`data:image/png;base64,${otpSettings.qrCode}`"
                class="border border-brand-gray-600 rounded-md w-32 h-auto"
              />
              <button
                class="text-primary"
                @click="$emit('onShowModal', 'authenticatorAppStep2Note')"
              >
                {{ $t('authenticatorAppStep2Note') }}
              </button>
            </div>
          </li>
          <li>
            <div class="flex flex-col items-start gap-y-2">
              <span>{{ $t('authenticatorAppStep3MSG') }}</span>
              <Form
                v-slot="{ resetForm }"
                class="w-1/3 flex flex-col gap-3"
                @submit="(values) => onSubmit(values, resetForm)"
              >
                <Field
                  :rules="requiredRule"
                  validate-on-input
                  validate-on-change
                  validate-on-blur
                  name="verificationCode"
                  v-slot="{ field, errors: errs }"
                >
                  <TextInput
                    :field="field"
                    :errors="errs"
                    label=""
                    label-class="w-full"
                    class="w-full"
                    direction="flex-col"
                  />
                </Field>
                <button
                  class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
                >
                  <span class="w-full text-center py-1.5">
                    {{ $t('Verify') }}
                  </span>
                </button>
              </Form>
            </div>
          </li>
        </template>
      </ol>
    </div>
    <div class="py-2 ltr:font-sans text-xs text-brand-black-secondary">
      <h5 class="text-base">{{ $t('note') }}</h5>
      <p>{{ $t('authenticatorAppMSG4') }} <slot name="mobileNumber"></slot></p>
      <p>{{ $t('SMSMsg2') }}</p>
    </div>
  </div>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import axiosInstance from '@/services'
import { Field, Form } from 'vee-validate'
import { onMounted, ref, provide } from 'vue'
import { useI18n } from 'vue-i18n'
import { notify } from 'notiwind'

const i18n = useI18n()

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

const otpSettings = ref()

onMounted(async () => {
  otpSettings.value = await axiosInstance.get('/api/user/getTotpSettings')
  sessionStorage.setItem('otpKey', otpSettings.value.key)
})

const onSubmit = async (form, resetForm) => {
  const body = {
    key: otpSettings.value.key,
    code: form.verificationCode
  }
  const response = await axiosInstance.post('/api/user/verifyTotpAndActivate', body)

  notify(
    {
      group: response ? 'success' : 'error',
      title: i18n.t(response ? 'activatedSuccessfully' : 'incorrectVerificationCode')
    },
    6000
  )

  resetForm()
}
</script>

<style lang="scss" scoped></style>
